// extracted by mini-css-extract-plugin
module.exports = {"container":"DeliveryCitiesPageModal_container__CaMis","container__wrapper":"DeliveryCitiesPageModal_container__wrapper__29p71"};